import { BankAccountItem } from "../../constants/bankAccounts";

interface Award {
  name: string;
  type: string;
  features: string[];
  images: File[];
  order: number;
}


interface AwardDTO {
  name: string;
  type: string;
  features: string[];
  images: string[];
  order: number;
}

interface ICreationRaffle {
  id?: string;
  name: string;
  limit: number;
  ticketPrice: number;
  ticketPriceUSD: number;
  type: string;
  sorterId?: string;
  status?: string;
  awards: Award[];
  accountId?: string;
  availablePaymentMethods: string[];
  launchDate?: number;
  hasReferenceNumber: boolean;
  bankAccounts: BankAccountItem[];
  isPremium: boolean;
  templateId: string;
}



interface ICreationRaffleImageDTO {
  accountId: string;
  imageName: string;
  imageFile: File;
  raffleId: string;
}

interface ICreationAccountImageDTO {
  accountId: string;
  imageName: string;
  imageFile: File;
}

interface ICreationRaffleDTO {
  id?: string;
  name: string;
  limit: number;
  ticketPrice: number;
  ticketPriceUSD: Number;
  type: string;
  sorterId?: string;
  status?: string;
  accountId?: string;
  hasReferenceNumber: boolean;
  awards: AwardDTO[];
  launchDate?: number;
  isPremium: boolean;
  availablePaymentMethods: string[];
  bankAccounts: BankAccountItem[];
  templateId: string;
}

export const InitialAwards: Award[] = [
  {
    name: "",
    type: "car",
    features: [],
    images: [],
    order: 0,
  },
];

export const InitialCreationRaffle: ICreationRaffle = {
  name: "",
  limit: 1000,
  ticketPrice: 1000,
  ticketPriceUSD: 2,
  type: "",
  awards: InitialAwards,
  availablePaymentMethods: [],
  bankAccounts: [],
  isPremium: false,
  hasReferenceNumber: false,
  templateId: 'default',
};

export const InitialCreationRaffleReset: ICreationRaffle = {
  name: "",
  limit: 1000,
  ticketPrice: 1000,
  ticketPriceUSD: 2,
  type: "",
  awards: InitialAwards,
  availablePaymentMethods: [],
  bankAccounts: [],
  isPremium: false,
  hasReferenceNumber: false,
  templateId: 'default'
};

export type {
  ICreationRaffle,
  ICreationRaffleDTO,
  ICreationRaffleImageDTO,
  Award,
  AwardDTO,
  ICreationAccountImageDTO,
};
